export const generateFlyoutId = (prefix, itemName = undefined) => {
  return itemName ? `${prefix}-${itemName?.replace(/\s+/g, '-')}` : prefix;
};
